import "../../css/NavBar.css";
import { useEffect, useRef } from "react";
import MobileMenu from "../MobileMenu";
import "../../css/MobileMenu.css";
import { useNavigate } from "react-router-dom";

const NavBarPortrait = ({ scrollToSection, mobileMenuVisible, setMobileMenuVisible }) => {
  const navigate = useNavigate();
  const infoContainerRef = useRef(null);

  const handleLogoClick = () => {
    window.scrollTo(0, 0);
    navigate('/');
  };

  const handleMobileMenuClick = () => {
    setMobileMenuVisible((prev) => !prev);

    if (!mobileMenuVisible) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  };

  const handleOutsideClick = (e) => {
    if (
      infoContainerRef.current &&
      !infoContainerRef.current.contains(e.target)
    ) {
      setMobileMenuVisible(false);
      document.body.classList.remove("menu-open");
    }
  };

  useEffect(() => {
    if (mobileMenuVisible) {
      document.body.style.overflow = "hidden";
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.body.style.overflow = "auto";
      document.removeEventListener("click", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [mobileMenuVisible]);

  return (
    <>
      <header>
        <div className="phone-container">
          <a href="tel:01273769270" className="phone-link">
            <img
              src="/Images/telephone.png"
              className="phone-logo"
              alt="phone logo"
            />
          </a>
        </div>
        <img
          src="/Images/BRS-logo.png"
          alt="Brighton roofing specialists Logo"
          className="BRS-logo"
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        />
        <div className="hamburger-container">
          <div
            className="hamburger-menu"
            onClick={handleMobileMenuClick}
            ref={infoContainerRef}
          >
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>
      </header>
      <MobileMenu
        mobileMenuVisible={mobileMenuVisible}
        scrollToSection={scrollToSection}
      />
    </>
  );
};

export default NavBarPortrait;